/* eslint-disable simple-import-sort/imports -- must evaluate before Recoil */
import './process-shim';
/* eslint-enable simple-import-sort/imports */

import React from 'react';
import ReactDOM from 'react-dom/client';

import * as Sentry from '@sentry/react';

import { ErrorBoundary } from '@/components/errors/error-boundary';
// eslint-disable-next-line no-restricted-imports
import { Analytics } from '@/lib/analytics/analytics';
import { extensionManager } from '@/lib/extension-manager';

import { App } from './app';
import { getConfig } from './config';
const { sentryDsn, amplitudeId, environment } = getConfig();
import { Buffer } from 'buffer';

import { Favicon } from './components/layout/favicon';
import { bootstrapPermissionOverridesFromUrl } from './lib/auth/permission-overrides-storage';
import { bootstrapAmplitudeFeatureFlagOverridesFromUrl } from './lib/feature-flags/url-and-storage';

bootstrapAmplitudeFeatureFlagOverridesFromUrl();
bootstrapPermissionOverridesFromUrl();

globalThis.Buffer = Buffer;

extensionManager.initialize();

if (sentryDsn) {
  Sentry.init({
    environment: environment,
    dsn: sentryDsn,
    release: import.meta.env.VITE_BUILD_HASH,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1, // 10% of transactions
    replaysSessionSampleRate: environment === 'prod' ? 0.05 : 0, // 5% of sessions in prod
    replaysOnErrorSampleRate: 1.0, // 100% of errors
    ignoreErrors: ['Large HTTP payload'],
    // v11 collects cookies, request bodies, and user info by default.
    // Keep the restrictive v10 sendDefaultPii-off baseline.
    // https://docs.sentry.io/platforms/javascript/guides/react/migration/v10-to-v11/
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      },
      httpBodies: [],
      urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      genAI: { inputs: false, outputs: false },
      databaseQueryData: false,
      graphQL: { document: false, variables: false },
    },
  });
}

Analytics.initialize({
  Amplitude: amplitudeId,
}).catch((error) => {
  if (sentryDsn) {
    Sentry.captureException(error);
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Favicon />
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
